import { Moment } from 'moment';
import QualityControlStatus from '@/shared/constants/QualityControlStatus';
import User from '@/shared/models/User';

export interface QualityControlId {__qualityControlId: number}

export default class QualityControl {
  id: QualityControlId | null = null;
  status = QualityControlStatus.TO_DO;
  dossierStatus!: QualityControlStatus;
  comment = '';
  modifiedOn: Moment | null = null;
  modifiedBy: User | null = null;
  isMandatory = false;

  static create(id: QualityControlId | null, status: QualityControlStatus, comment: string, isMandatory: boolean): QualityControl {
    const qualityControl = new QualityControl();
    qualityControl.id = id;
    qualityControl.status = status;
    qualityControl.comment = comment;
    qualityControl.isMandatory = isMandatory;
    return qualityControl;
  }

  get isPending(): boolean {
    return (this.status === QualityControlStatus.TO_DO
            || this.status === QualityControlStatus.ONGOING)
            && this.isMandatory;
  }

  clone(): QualityControl {
    return Object.assign(new QualityControl(), this);
  }
}
